import { render, staticRenderFns } from "./contact-item.vue?vue&type=template&id=db44e2a0&scoped=true&"
import script from "./contact-item.vue?vue&type=script&lang=js&"
export * from "./contact-item.vue?vue&type=script&lang=js&"
import style0 from "./contact-item.vue?vue&type=style&index=0&id=db44e2a0&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db44e2a0",
  null
  
)

export default component.exports